import { Avatar } from "@mui/material";
import { blue } from "@mui/material/colors";
import React, { Component } from "react";
import { IPropsIcone } from "../../modelo/Icone";

class IconeEsij extends Component<IPropsIcone> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      // <Avatar src="./img/esij.png" variant="square" style={{width: '32px', height:'32px'}} imgProps={{ style: { objectFit: 'scale-down' } }} />
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="32px" height="32px" viewBox="0 0 762.000000 327.000000"
        preserveAspectRatio="xMidYMid meet"
      >

        <g transform="translate(0.000000,327.000000) scale(0.100000,-0.100000)"
          className="icone-sistema-origem-base" fill="#000000" stroke="none">
          <path d="M3453 3069 c-271 -35 -510 -174 -635 -370 -36 -56 -62 -109 -71 -144
            -3 -11 -13 -45 -22 -75 -18 -65 -21 -240 -5 -329 39 -214 156 -373 365 -496
            93 -55 193 -95 400 -159 335 -105 484 -200 525 -335 24 -76 25 -127 4 -206
            -32 -125 -116 -221 -248 -285 -139 -67 -270 -85 -411 -55 -160 34 -286 102
            -375 204 -30 33 -58 61 -62 61 -13 0 -287 -234 -287 -246 -1 -18 121 -138 186
            -182 303 -205 797 -241 1131 -82 110 52 163 90 245 175 170 175 248 442 203
            695 -29 159 -76 243 -201 358 -56 51 -100 79 -205 133 -53 26 -146 61 -215 79
            -413 109 -605 218 -665 376 -18 50 -21 74 -18 154 3 80 8 105 32 153 54 111
            165 196 303 232 79 21 282 20 354 -1 88 -26 187 -83 250 -146 32 -32 62 -58
            66 -58 3 0 27 19 52 43 26 23 88 80 138 126 l92 84 -26 33 c-39 52 -146 133
            -227 172 -160 78 -461 119 -673 91z"
          />
          <path d="M4770 1675 l0 -1335 175 0 175 0 0 1335 0 1335 -175 0 -175 0 0 -1335z" />
          <path d="M6468 2008 l-3 -1003 -26 -91 c-33 -119 -92 -204 -174 -253 -227
            -137 -502 -35 -582 215 l-16 51 -36 -9 c-20 -5 -96 -21 -169 -37 -73 -16 -135
            -31 -138 -34 -10 -9 35 -146 73 -224 113 -232 374 -366 683 -350 130 7 276 42
            350 84 25 14 58 33 74 41 16 8 63 50 105 92 92 93 150 197 189 337 l27 98 3
            1043 3 1042 -180 0 -180 0 -3 -1002z"/>
          <path d="M1300 2294 c-388 -83 -666 -347 -767 -725 -24 -93 -27 -121 -27 -274
            -1 -153 2 -181 27 -278 94 -372 354 -630 715 -709 136 -29 365 -29 510 0 118
            24 247 76 346 140 70 45 192 155 226 202 l19 27 -136 102 -135 103 -59 -61
            c-105 -108 -209 -176 -315 -207 -44 -13 -86 -15 -193 -12 -127 4 -142 7 -227
            40 -153 60 -255 143 -327 263 -38 63 -67 159 -67 219 l0 36 776 0 776 0 -4
            163 c-4 132 -10 183 -32 277 -52 214 -160 395 -309 518 -97 80 -261 153 -397
            178 -96 17 -316 16 -400 -2z m425 -313 c193 -78 296 -223 323 -453 l8 -68
            -583 0 -583 0 0 31 c0 54 30 152 68 219 80 145 216 249 392 299 19 6 94 9 165
            8 120 -3 136 -6 210 -36z" style={{ fill: blue[500] }} />
        </g>
      </svg>
    );
  }
}

export default IconeEsij;
